import { OpportunityType } from '../types/api/opportunities.js';
import {
  RecommendationDeclineReason,
  RecommendationStatus,
} from '../types/models/recommendation.js';

export const RECOMMENDATION_STATUS_LABELS: Record<RecommendationStatus, string> = {
  [RecommendationStatus.PENDING]: 'En attente',
  [RecommendationStatus.ACCEPTED]: 'Acceptée',
  [RecommendationStatus.DECLINED]: 'Déclinée',
};

export const RECOMMENDATION_DECLINE_REASON_LABELS: Record<RecommendationDeclineReason, string> = {
  [RecommendationDeclineReason.NOT_INTERESTED_FOR_PROFILE]:
    "Le contenu de l'offre est adapté à mon profil mais ne m'intéresse pas",
  [RecommendationDeclineReason.OFF_TOPIC]:
    "Le contenu de l'offre n'est pas adapté à mon profil (hors sujet)",
  [RecommendationDeclineReason.LOCATION]: 'La localisation ne me convient pas',
  [RecommendationDeclineReason.SALARY]: 'Le salaire ne me convient pas',
  [RecommendationDeclineReason.OTHER]: 'Autre raison',
};

export const RECOMMENDATION_ACCEPT_CTA_LABELS: Record<OpportunityType, string> = {
  [OpportunityType.JOB_OFFER]: "J'ai postulé",
  [OpportunityType.EVENT]: 'Je participe',
  [OpportunityType.CONTACT]: "J'ai pris contact",
};

export const RECOMMENDATION_ACCEPTED_STATUS_LABELS: Record<OpportunityType, string> = {
  [OpportunityType.JOB_OFFER]: "J'ai postulé",
  [OpportunityType.EVENT]: "J'ai participé",
  [OpportunityType.CONTACT]: "J'ai pris contact",
};

export const RECOMMENDATION_DECLINED_STATUS_LABEL = "J'ai décliné";

export const RECOMMENDATION_DECLINE_LINK_LABEL = 'Je ne suis pas intéressé(e)';
